import * as React from 'react';
import { Image, Text, View, StyleSheet, Platform, Pressable } from 'react-native';
import * as AppConstants from "../context/AppConstants";

const styles = StyleSheet.create({
  wrapper: {
    margin: 10,
  },
  titleWrapper: {
    flexDirection: "row",
    alignItems: "center",
  },
  titleText: {
    fontWeight: "bold",
    paddingLeft: 10,
  },
  contentWrapper: {
    padding: 20,
  }
});

export function Collapsible({ title, expanded, children, expandedBackref }) {
  const [collapsed, setCollapsed] = React.useState(expanded ? false : true);

  const onTitlePress = () => {
    const newCollapsed = !collapsed;
    if (expandedBackref) {
      expandedBackref(!newCollapsed);
    } else {
      setCollapsed(newCollapsed);
    }
  }

  const isCollapsed = expandedBackref ? !expanded : collapsed;

  return (
    <View style={styles.wrapper}>
      <Pressable style={styles.titleWrapper} onPress={onTitlePress}>
        {
          isCollapsed ?
              <Image source={require('../../assets/chevron-right-black-25.png')} style={AppConstants.STYLES.image25x25} />
            :
              <Image source={require('../../assets/chevron-down-black-25.png')} style={AppConstants.STYLES.image25x25} />
        }
        <Text style={styles.titleText}>{title}</Text>
      </Pressable>
      {
        isCollapsed ? null :
          <View style={styles.contentWrapper}>
            { children }
          </View>
      }
    </View>
  );
}
